import { inViewMargin } from '@helpers/animate';
import { formatDate, formatDateISO } from '@helpers/formatters';
import { withMotion } from '@hoc/withMotion';
import { useInView } from '@hooks/useInView';
import MediaCard from '@stories/Components/MediaCard/MediaCard';
import { MotionConfig } from 'framer-motion';
import * as React from 'react';
import MediaCarousel from '../MediaCarousel/MediaCarousel';
import BlockQuoteBlock from './BlockQuoteBlock/BlockQuoteBlock';
import ImageBlock from './ImageBlock/ImageBlock';
import S from './MediaDetailContentSection.styles';
import RichTextBlock from './RichTextBlock/RichTextBlock';
import VideoEmbedBlock from './VideoEmbedBlock/VideoEmbedBlock';
import ImageCarouselBlock from './ImageCarouselBlock/ImageCarouselBlock';
const RelatedItem = (props) => {
    const [refContainer, inView] = useInView({ rootMargin: inViewMargin });
    return (React.createElement(S.RelatedItem, { ref: refContainer, initial: "hidden", animate: inView ? 'visible' : 'hidden', variants: {
            hidden: {
                opacity: 0,
                y: 20,
            },
            visible: {
                opacity: 1,
                y: 0,
            },
        } },
        React.createElement(MediaCard, { ...props })));
};
const MediaDetailContentSection = ({ accentColor, blocks, date, id, relatedItems, tag, }) => {
    const [refContainer, inView] = useInView({ rootMargin: inViewMargin });
    return (React.createElement(MotionConfig, { transition: { duration: 0.3, ease: 'easeOut' } },
        React.createElement(S.Container, { ref: refContainer, id: id, style: { '--accentColor': accentColor } },
            React.createElement(S.Inner, { initial: "hidden", animate: inView ? 'visible' : 'hidden' },
                React.createElement(S.MetaWrapper, { variants: {
                        hidden: { opacity: 0, y: 20 },
                        visible: { opacity: 1, y: 0 },
                    } },
                    React.createElement(S.Tag, null, tag),
                    React.createElement(S.Date, { dateTime: formatDateISO(date) }, formatDate(date))),
                React.createElement(S.ContentWrapper, null, blocks.map(renderBlock)),
                React.createElement(S.RelatedWrapper, null,
                    React.createElement(S.RelatedTitle, { variants: {
                            hidden: { opacity: 0, y: 20 },
                            visible: { opacity: 1, y: 0 },
                        } }, "Related Stories"),
                    relatedItems.map((item) => (React.createElement(RelatedItem, { key: item.id, ...item })))))),
        React.createElement(S.RelatedCarousel, null,
            React.createElement(MediaCarousel, { title: "Related Stories", items: relatedItems.map((item) => ({ ...item, content: '' })), themeOption: "light" }))));
    function renderBlock(block) {
        switch (block.name) {
            case 'blockQuote':
                return React.createElement(BlockQuoteBlock, { ...block });
            case 'image':
                return React.createElement(ImageBlock, { ...block });
            case 'richText':
                return React.createElement(RichTextBlock, { ...block });
            case 'videoEmbed':
                return React.createElement(VideoEmbedBlock, { ...block });
            case 'imageCarousel':
                return React.createElement(ImageCarouselBlock, { ...block });
            default:
                return null;
        }
    }
};
export default withMotion(MediaDetailContentSection);
